<template>
    <div>
        <LoadingOverlay :show="processingLogout">
            <Sidebar :openSidebar="sidebarTriggered" :staticSidebarState="staticSidebarOpen" @sidebarClosed="sidebarTriggered = false"></Sidebar>
            <div
                :class=" {
                    'lg:pl-60': staticSidebarOpen,
                    'lg:pl-20': !staticSidebarOpen
                }"
                class="flex min-h-screen min-w-0 flex-col transition-all duration-150 ease-in-out"
            >
                <Topbar
                    @sidebarOpen="sidebarTriggered = true"
                    @toggleStaticSidebar="staticSidebarOpen = !staticSidebarOpen"
                    @logging-out="processingLogout = true"
                    @logging-out-complete="processingLogout = false"
                />
                <main class="min-w-0 flex-grow pb-4">
                    <slot/>
                </main>
                <Footer></Footer>
            </div>
        </LoadingOverlay>

        <WelcomeStartTourModal
            :open="showWelcome"
            @start="onWelcomeStart"
            @later="onWelcomeLater"
            @dismiss="onWelcomeDismiss"
        />

        <!-- Outside the padded column on purpose: it is pinned to the viewport,
             not to the page, so it must not inherit the sidebar offset. It
             hides itself when the addon is off, when the operator has turned
             the bubble off, and on /ask itself. -->
        <AskLauncher/>
    </div>
</template>

<script setup>
import Sidebar from '@/components/Layout/Main/Sidebar.vue';
import Topbar from '@/components/Layout/Main/Topbar.vue';
import Footer from '@/components/Layout/Main/Footer.vue';
import LoadingOverlay from '@/components/LoadingOverlay.vue';
import WelcomeStartTourModal from '@/components/Help/WelcomeStartTourModal.vue';
import AskLauncher from '@/components/Portal/Ask/AskLauncher.vue';
import { computed, onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useAuthStore } from '@/stores/auth-store.js';
import { useHelpStore } from '@/stores/help-store.js';
import { useHelpTour } from '@/composables/useHelpTour.js';

// Breadcrumbs are rendered by Layout.vue with the page's own content — this
// shell now outlives the page and never sees its props.
const auth = useAuthStore();
const helpStore = useHelpStore();
const { startTour } = useHelpTour();
const route = useRoute();

const processingLogout = ref(false);
const sidebarTriggered = ref(false);
const staticSidebarOpen = ref(auth && auth.user && auth.user.sidebar === 'open');

const showWelcome = computed(() => {
    if (!auth.isLoggedIn || auth.user?.must_change_password) {
        return false;
    }
    if (route.name === 'force_password') {
        return false;
    }
    return helpStore.shouldShowWelcome;
});

onMounted(() => {
    if (auth.isLoggedIn && !auth.user?.must_change_password) {
        helpStore.load();
    }
});

const onWelcomeStart = async () => {
    await helpStore.dismissWelcome(true);
    await startTour('getting-started', { forceRestart: true });
};

const onWelcomeLater = async () => {
    await helpStore.dismissWelcome(false);
};

const onWelcomeDismiss = async () => {
    await helpStore.dismissWelcome(true);
};
</script>

<style scoped></style>